<div class="input-container">
  <div class="combined-input">
    <!-- Numeric Input -->
    <input
      type="number"
      class="input cost-input"
      placeholder="Enter amount"
      [disabled]="disabled"
      [value]="value.amount"
      (input)="updateAmountOnInput($event)"     
      (blur)="onAmountBlur()"           
    >

    <!-- Currency Dropdown -->
    <select
      class="input currency-select"
      [disabled]="disabled"
      (change)="updateCurrency($event)" 
      (blur)="onTouched()"
    >
      <option *ngFor="let c of currencies" [value]="c" [selected]="c === value.currency">
        {{ c }}
      </option>
    </select>
  </div>
</div>
